// Leaflet's stylesheet is not global (removed from `css` in nuxt.config.ts): it loads together with the first map that
// mounts. Render the map only when `ready` is true so it never paints without its styles.
export const useLeafletStyles = () => {
	const ready = ref(false)

	onMounted(async () => {
		await import('leaflet/dist/leaflet.css')
		ready.value = true
	})

	return ready
}
